import React from 'react';
import { WebAuthSocialsButtons, WebAuthSocialsButtonsProps } from './web-social-buttons';

// tslint:disable-next-line: no-empty-interface
interface AuthSocialsButtonsProps extends WebAuthSocialsButtonsProps {
  fullSize?: boolean;
}


const AuthSocialsButtons: React.FC<AuthSocialsButtonsProps> = (props) => {
  const {
    withSuggestionBefore,
    onSocialLogin,
    fullSize,
  } = props;


  return (
    <WebAuthSocialsButtons
      withSuggestionBefore={withSuggestionBefore}
      onSocialLogin={onSocialLogin}
      fullSize={fullSize}
    />
  );
};

export default AuthSocialsButtons;
